module.exports = __webpack_public_path__ + "static/img/right-top-row-2.923594d1.webp";